module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Bold-WebS.9e75ee4c.eot";